<template>
	<div class="upload">
		<template v-if="more">
			<!-- 多文件上传 -->
			<input accept=".png,.gif,.jpg,.jpeg" type="file" multiple @change='upload($event)'>
		</template>
		<template v-else>
			<!-- 单文件上传 -->
			<input accept=".png,.gif,.jpg,.jpeg" type="file" @change='upload($event)'>
		</template>
		<slot>
			<el-button :type='type' :size='size'>{{buttonTitle}}</el-button>
		</slot>
	</div>
</template>

<script>
	export default {
		name: 'Uploads',
		props: {
			buttonTitle: {
				type: String,
				default: '上传'
			},
			customParams: {
				type: Array,
				default: function() {

					return [];
				}
			},
			type: {
				type: String,
				default: 'primary'

			},
			size: {
				type: String,
				default: 'small'
			},
			/**
			 * 多文件上传
			 */
			more: {
				type: Boolean,
				default: false

			},
			/* 
			* return  upload_main  上传至 /mnt/hgfs/img.cosonsen.com/product/upload_main 目录
			* return  upload_thumb  上传至 /mnt/hgfs/img.cosonsen.com/product/upload_thumb 目录
			*  */
			upload_path: {
				type: String,
				default: ''
			},
			/**
			 * 每张图片最大上传大小 这里指字节  (默认 1M )
			 */
			maxSize: {
				type: Number,
				default: 1048576
			},
			/**
			 * 裁剪宽度（相当于压缩，高度自定义,0为不裁剪）
			 */
			resize: {
				type: Number,
				default: 0
			},
			/**
			 * 到达某个大小后需要被裁剪(默认200kb)
			 */
			maxResizeByte: {
				type: Number,
				default: 204800
			}

		},
		data() {
			return {

			}
		},
		methods: {
			upload(event) {
				if (event.target.files.length <= 0) return this.alertWarn('图片未上传!!!');
				// 判断 上传文件 大小
				for (let i in event.target.files) {
					let size = event.target.files[i].size
					let name = event.target.files[i].name
					if (size > this.maxSize) return this.alertWarn(name+'图片超过1M !!!')
				}
				
				if(this.more){
					//多文件上传
					// upload_path必填 eg:<upload buttonTitle='上传' upload_path='upload_main' :resize='750' @success-upload='imgSuccess_SingleFile'></upload>
					if(this.upload_path=='') return this.$message.error('未指定上传目录')
					this.uploadFile(event,{resize:this.resize,maxResizeByte:this.maxResizeByte,upload_path:this.upload_path}).then((re) => {
						// console.log(re)
						this.$emit('success-upload', re.data, this.customParams);
					}).catch((err) => {
					
					})
				}else{
					//单文件上传
					// upload_path必填 eg:<upload buttonTitle='上传' upload_path='upload_thumb' :resize='750' @success-upload='imgSuccess_SingleFile'></upload>
					if(this.upload_path=='') return this.$message.error('未指定上传目录')
					this.uploadFile(event,{resize:this.resize,maxResizeByte:this.maxResizeByte,upload_path:this.upload_path}).then((re) => {
						this.$emit('success-upload', re.data[0], this.customParams);
					}).catch((err) => {
					
					})
				}
				
			}
		},
		computed: {

		},
		created() {

		}
	}
</script>

<style>
	.upload {
		position: relative;
		width: -webkit-fit-content;

	}

	.upload>input {
		width: 100%;
		height: 100%;
		opacity: 0;
		position: absolute;

	}
</style>